import HomePage from "./homepage/landing";
import BackToTop from "./backToTop";

export default function Home() {
  return (
    <>
      <main className="">
        <HomePage />
        <BackToTop />
      </main>
    </>
  );
}
